/**
 * check if apple device
*/
const expression = /(Mac|iPhone|iPod|iPad)/i;
const result = expression.test(navigator.platform);

export default result;